<template>
  <CardChart
    v-if="showComponent"
    :item-id="itemId"
    :width="width"
    :height="height"
  >
    <template v-slot:default="scopedSlot">
      <component
        :is="componentFile"
        :item-id="itemId"
        v-bind="{...customProps, ...scopedSlot, height, width}"
        v-on="$listeners"
      />
    </template>
  </CardChart>
</template>

<script>
import CardChart from '@/components/cards/models/CardChart';

export default {
  name: 'DynamicImportComponent',
  components: {
    CardChart,
  },
  props: {
    componentName: {
      type: String,
      required: true,
    },
    itemId: {
      type: [String, Number],
      required: true,
    },
    customProps: {
      type: Object,
      required: true,
    },
    width: {
      type: Number,
      default: 0,
    },
    height: {
      type: [Number, String],
      default: 0,
    },
  },
  data() {
    return {
      showComponent: true,
    };
  },
  computed: {
    componentFile() {
      return () => import(/* webpackPrefetch: true */ `./../${this.componentName}.vue`);
    },
  },
  mounted () {
    if (this.$props.componentName) {
      this.loadComponent();
    }
  },
  methods: {
    loadComponent () {
      this.componentFile()
        .catch(err => {
          console.error('Failed to load component', err);
          this.showComponent = false;
        });
    },
  },
};
</script>
